import React from 'react';

import mixin from 'react-mixin';
import { forwardPropsToState } from '../../../utils/react_utils';
import LecomLabel from '../../../form/components/label/label.jsx';
import OptionsPropsHelper from '../../../form/helpers/options_props_helper';
import RestClient from 'rest_client/rest_client';
import { formatFieldValue } from 'form/helpers/field_value_formatter';
import { FormAPI } from 'lecom-api';
import { FormEvents } from '../../../form/events/form_event_handler';

const keys = {37: 1, 38: 1, 39: 1, 40: 1};
let isDownActiveItem = false;

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([
	{prop: 'value', defaultValue: []},
	{prop: 'options', defaultValue: []},
	{prop: 'isVisible', defaultValue: false},
	{prop: 'isChange', defaultValue: false}
])

export default class InputSelectSearch extends React.Component {
	componentDidMount() {
		if (this.props.optionsUrl !== undefined) {
			const url = OptionsPropsHelper.buildOptionsUrl(this.props.optionsUrl, this.props.optionsUrlParams, true);

			RestClient.get(url)
				.then(response => this.handleOptionsRequestSuccess(response))
				.catch(err => this.handleOptionsRequestError(err));
		}
		this.active = null;

		const nodeInput = $(`#input__${this.getPropsId()}`);
		nodeInput.mouseup(() => this.rePositionResults());
		nodeInput.mousedown(() => this.rePositionResults());

		$(window).blur(() => {
			if(!this.state.isVisible) return true;
			this.setHiddenState(false);
		})

		this.removeStyleReadOnly();
	}

	componentDidUpdate(prevProps, prevState) {
		this.rePositionResults();

		if (!this.state.value || (this.state.value && Array.isArray(this.state.value) && !this.state.value.length)) {
			if ((this.state.newValue && typeof this.state.newValue !== 'object') || (typeof this.state.newValue === 'object' && this.state.newValue !== null && Object.keys(this.state.newValue).length)) {
				this.setState({ newValue: '' });
			}
		}
	}

	focusAutoComplete(id){
		if($('#documentModal').is(':visible') === true){
			$('#autocomplete_select_undefined').attr('tabindex', '-1');
			if(id !== undefined){
				let input = $(`#input__${id} #autocomplete_select_${id}`);
				let button = $(`#input__${id} .caret`);
				input.attr('tabindex', '-1');
				button.attr('tabindex', '-1');
				button.attr('tabindex', '0');;

				button.unbind('click').on('click', () => {
					if($('.fields-document-edit').is(':visible') === true){
						$('.fields-document-edit').animate({scrollTop: 300}, 500);
					}
				});

				let boxSearch = $(`#boxSearch__${id} input`);
				boxSearch.unbind('focus').on('focus', (e) => {
					$('.modal-content-container').animate({scrollTop: 300}, 500);
					boxSearch.off('focus');
				});
			}
		}
	}

	rePositionResults() {
		const nodeInput = $(`#input__${this.getPropsId()}`);
		const nodeResult = nodeInput.find(".input-autocomplete__result");
		const elem = $(`#${this.getPropsId()}`).parents('.realize-modal');

		if(elem && elem.is(':visible')){
			$(`#boxSearch__${this.getPropsId()}`).css({top: '40px'});
		}else if (nodeResult.length) {
			const nodeInputTop = nodeInput.offset().top;
			const nodeResultHeight = nodeResult.height();
			const maxResultHeight = nodeInputTop + nodeResultHeight;
			const windowHeight = window.innerHeight;
			const boxSearch = $(`#boxSearch__${this.getPropsId()}`);
			const form = document.getElementById(this.props.formId) || (document.getElementsByTagName('form') && document.getElementsByTagName('form')[0]);

			if (form && form.offsetHeight < maxResultHeight)
				boxSearch.css('top', `-${boxSearch.height() - 60}px`);
			else
				boxSearch.css('top', '43px');
		}
	}

	componentWillMount(){
		$(document).unbind('click');
		$(window).unbind('blur');
	}

	onClickDocument(e) {
		if(!this.state.isVisible) return true;

		e.stopPropagation();
		e.preventDefault();

		if(e.target.id && $(`#${this.getPropsId()}_element`).find(`#${e.target.id}`).length > 0){
			return false;
		}else if(e.target.type !== "submit"){
			this.setHiddenState(false, false);
		}
	}

	handleOptionsRequestSuccess(response) {
		const options = response.entity._embedded.fieldOptions || [];
		const id = this.getPropsId();

		if (this.props.gridFormParent) {
			if (Form.grids(this.props.gridFormParent) && Form.grids(this.props.gridFormParent).fields(id)) {
				Form.grids(this.props.gridFormParent).fields(id).options(options).apply();
				Form.grids(this.props.gridFormParent).fields(id).publish(FormEvents.LOAD_OPTIONS_SUCCESS, options);
			}
		}
		else {
			if (Form.fields(id)) {
				Form.fields(id).options(options).apply();
				Form.fields(id).publish(FormEvents.LOAD_OPTIONS_SUCCESS, options);
			}
		}
	}

	handleOptionsRequestError(err) {
	}

	setDefaultValue() {
		const { defaultValue, value, id } = this.props;

		const hasNoValue = !value || value.length === 0;

		const isTemplate = id && id.includes("_templateField");

		return hasNoValue && defaultValue && !isTemplate;
	}

	getSelectedValue() {
		const { newValue, value } = this.state;
		const { defaultValue, gridFormParent } = this.props;

		if (newValue) {
			return newValue.name;
		}

		if (typeof value === 'object') {
			return value.name || value[0];
		}

		if (this.setDefaultValue()) {
			if (gridFormParent) {
				const { formId, id } = this.props;
				const formApi = FormAPI.form(formId);

				formApi.grids(gridFormParent).fields(id).value(defaultValue).apply();
			}

			return defaultValue;
		}

		return value;
	}

	selectedValue() {
		const { id, gridFormParent, options } = this.props;

		const value = this.getSelectedValue();

		let newValue = [];
		let selectOptions = [];

		if (gridFormParent) {
			const fieldGrid = Form.grids(gridFormParent).fields(id);

			selectOptions = (id && fieldGrid) ? fieldGrid.options() : (options || []);
		} else {
			const field = Form.fields(id);

			selectOptions = (id && field) ? field.options() : (options || []);
		}

		const hasOptions = selectOptions && selectOptions.length > 0;

		if (hasOptions) {
			newValue = selectOptions.filter((opt) => opt.value === value || opt === value);
		}

		return this.formatOption((newValue && newValue.length > 0 && newValue[0].name) || value || '');
	}

	autocompleteReadOnly(){
		const readOnly = this.props.readOnly;
		const disabled = this.props.disabled;

		if(readOnly === true || disabled === true){
			return ''
		} else {
			return <span aria-hidden="true">▼</span>
		}
	}

	classNameReadOnly(){
		return this.props.readOnly === true ? ' readonly-autocomplete' : '';
	}

	setHiddenState(status, isfocused=true){
		if(status){
			$(document).click(this.onClickDocument.bind(this));
			$(`.input-autocomplete__result.id__${this.getPropsId()}`).css("display", "block");
			document.getElementById(`${this.getPropsId()}__search`).focus();
			this.setState({isVisible: status});
			$('.input-autocomplete__option').removeClass('active');
			setTimeout(()=>{
				this.rePositionResults();
			}, 0);
		}else if(!status){
			if (isfocused) {
				$(`#${this.getPropsId()}`).focus();
			}

			$(document).unbind('click');
			this.enableScroll();
			$(`.input-autocomplete__result.id__${this.getPropsId()}`).css("display", "none");
			this.active = null;
			this.setState({isVisible: status, newValue: '', searchValue: ''});
		}
	}

	setNewValue(value) {
		const id = this.getPropsId();

		this.setState({ value }, () => {
			if (this.props.gridFormParent) {
				if (Form.grids(this.props.gridFormParent) && Form.grids(this.props.gridFormParent).fields(id)) {
					Form.grids(this.props.gridFormParent).fields(id).value(value.value || value.name || value).apply();
				}
			} else {
				if (Form.fields(id)) {
					Form.fields(id).value(value.value || value.name || value).apply();
				}
			}
		});
	}

	handleClickClear(e) {
		e.stopPropagation();
		e.preventDefault();
		this.setNewPropertys('', false, e);
	}

	handleClearOptionSelected(e) {
		e.stopPropagation();
		e.preventDefault();

		if((e.keyCode && e.keyCode === 13) ) {
			this.setNewPropertys('', false);
			var self = this;
			setTimeout(() => {
				document.getElementById(`${self.getPropsId()}_caret`).focus();
			}, 0);

		}else {
			this.keyDownEvents(e)
		}
	}

	setFocusNextElement(_elem){
		const elem = document.getElementById(`input__${this.props.id}`);
		const nextElement = _elem ? _elem.nextElementSibling : null;

		if(nextElement){
			if(nextElement.classList.value.match('hide') && nextElement.nextElementSibling){
				setTimeout(() => this.setFocusNextElement(nextElement.nextElementSibling), 1000);
				return false;
			}else if(nextElement.classList.value.match('hide') && !nextElement.nextElementSibling){
				return false
			}

			this.setFocusNewElement(nextElement);
		}else if(elem.nextElementSibling) {
			if(elem.nextElementSibling.classList.value.match('hide') && elem.nextElementSibling.nextElementSibling){
				setTimeout(() => this.setFocusNextElement(elem.nextElementSibling.nextElementSibling), 1000);
				return false;
			}else if(elem.nextElementSibling.classList.value.match('hide') && !elem.nextElementSibling.nextElementSibling){
				this.setFocusCaret();
				return false
			}
			let id = elem.nextElementSibling.id.split('_')[2];
			id && $("#" + id).focus();
		}else {
			this.setFocusCaret();
		}
	}

	setFocusCaret(){
		setTimeout(() => {
			document.getElementById(`${this.getPropsId()}_caret`).focus();
		}, 0);
	}

	setFocusNewElement(nextElement){
		const listLabel = $(nextElement).find('label');
		const caret = $(nextElement).find('.caret');

		if(caret && caret.length === 1){
			caret.focus();
			return
		}

		if(listLabel.length > 1) {
			let nextElem = false;
			for(let i = 0; i < listLabel.length; i++){
				const item = listLabel[i];
				if($(item).attr('tabindex') === "0") {
					nextElem = true;
					return $(item).focus();
				}
			}
			if(!nextElem && nextElement.nextElementSibling)this.setFocusNewElement(nextElement.nextElementSibling);
		}else{
			const elem = listLabel[0];
			const id = this.getPropsId();
			if(elem && id && document.getElementById(id).getAttribute('aria-disabled') !== "true")
				elem.focus();
			else if(nextElement && nextElement.nextElementSibling){
				this.setFocusNewElement(nextElement.nextElementSibling);
			}else{
				this.setFocusCaret();
			}
		}
	}

	setNewPropertys(value, flag, e){
		this.setHiddenState(flag);
		this.setNewValue(value);

		if(e !== undefined)
			this.props.onChange(e);
	}

	replaceCaracter(str) {
		if(str) {
			str = str.replace(/[ÀÁÂÃÄÅ]/g,"A");
			str = str.replace(/[àáâãäå]/g,"a");
			str = str.replace(/[ÈÉÊË]/g,"E");
			str = str.replace(/[èéê]/g,"e");
			str = str.replace(/[ÒÓÕÔ]/g,"O");
			str = str.replace(/[óÒôõ]/g,"o");
			str = str.replace(/[úùû]/g,"O");
			str = str.replace(/[ÙÚÛ]/g,"o");
			return str;
		}
		return '';
	}

	getListOptions() {
		const { search } = this.state;

		let optionSelected = typeof search === 'object' ? (search.value ? search.value : search[0]) : (search ? search : '');
		const options = this.props.options || [];

		if (options && Array.isArray(options)) {
			return options
				.map(o => ({
					name: typeof o.name === 'string' ? o.name.trim() : o.name,
					value: typeof o.value === 'string' ? o.value.trim() : o.value
				}))
				.filter(o => o.name !== "");
		}

		return this.filterSearch(options, optionSelected);
	}

	filterSearch(list, value) {
		if(value && value !== "")
			return list.filter((item) => {
				if(this.replaceCaracter(item.value.toLowerCase()).match(this.replaceCaracter(value.toLowerCase()))) return item;
			});
	}

	handleOnKeyUpSearch(e){
		if(e.keyCode === 13){
			let filterOptions = [];
			let formApi = FormAPI.form(this.props.formId);

			if(this.props.gridFormParent === "" || this.props.gridFormParent === null){
				let options = this.props.options;

				if(this.state.searchValue && this.state.searchValue.length > 0) {
					filterOptions = options.filter(item => {
						const check = this.replaceCaracter(item.name.toLowerCase()).match(this.replaceCaracter(this.state.searchValue.toLowerCase()));
						if(check) return item;
					});
				}


				if(filterOptions.length > 0 && this.props.id)
					formApi.fields(this.props.id).value(filterOptions[0].value).apply();
			}
			else {
				let options = this.props.options;
				let filterOptions = options.filter(item => {
					const check = this.replaceCaracter(item.name.toLowerCase()).match(this.replaceCaracter(this.state.searchValue.toLowerCase()));
					if(check) return item;
				});


				if(filterOptions.length > 0)
					formApi.grids(this.props.gridFormParent).fields(this.props.id).value(filterOptions[0].value).apply();
			}
		}
		else if(e.keyCode === 9 && !e.shiftKey) {
			$(`#${this.getPropsId()}_clear`).focus();
			return true
		}
		else if(e.keyCode === 9 && e.shiftKey) {
			this.setHiddenState(false);
			this.setFocusCaret();
			return true
		}
		else {
			isDownActiveItem = true;
			this.keyDownEvents(e);
		}
	}

	keyDownEvents(e){
		if(e.keyCode === 27) {
			this.setHiddenState(false);
			this.setFocusCaret();
		}else if(e.keyCode === 40) {
			e.stopPropagation();
			e.preventDefault();
			if(e.currentTarget.nextElementSibling)
				e.currentTarget.nextElementSibling.focus();
			else this.moveActiveDown(e);
		}else if(e.keyCode === 38) {
			e.stopPropagation();
			e.preventDefault();
			if(e.currentTarget.previousElementSibling)
				e.currentTarget.previousElementSibling.focus();
			else  this.moveActiveUp(e);
		}
	}

	moveActiveUp() {
		let liBoxSearch = $(`#boxSearch__${this.getPropsId()} .input-autocomplete__list li`);
		this.active = Math.max(0, this.active -1);
		liBoxSearch.removeClass('active');
		liBoxSearch.eq( this.active ).focus();
	}

	moveActiveDown(e) {
		let liBoxSearch = $(`#boxSearch__${this.getPropsId()} .input-autocomplete__list li`);

		if (document.activeElement && $(document.activeElement).index() !== -1 && $(document.activeElement).index() + 1 === liBoxSearch.length) {
			return;
		}
		else {
			this.nextElementLiActive();
			liBoxSearch.removeClass('active');
			liBoxSearch.eq( this.active ).focus();
		}
	}

	handleOnKeyUp(item, e) {
		if(item && e.keyCode === 13){
			this.handleOnClick(item, e);
		}else {
			if (!isDownActiveItem) {
				this.keyDownEvents(e);
			}

			isDownActiveItem = false;
		}
	}

	handleOnFocus(e) {
		this.setFocusLI(e.currentTarget);
	}

	setFocusLI(element) {
		$('.input-autocomplete__option').removeClass('active');
		element.focus();
		$(element).addClass('active');
	}

	handleRemoveLiActive(){
		$('.input-autocomplete__option').removeClass('active');
		this.active = null;
	}

	nextElementLiActive(){
		let liBoxSearch = $(`#boxSearch__${this.getPropsId()} .input-autocomplete__list li`);
		let lengthLi = liBoxSearch.length;
		this.active = (this.active >= (lengthLi -1) || this.active === null) ? 0 : this.active+1;
	}

	preventDefault(e) {
		if(e || window.event) {
			e = e || window.event;
			if (e.preventDefault)
				e.preventDefault();

			e.returnValue = false;
		}
	}

	preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			this.preventDefault(e);
			return false;
		}
	}

	disableScroll() {
		if (window.addEventListener)
			window.addEventListener('DOMMouseScroll', this.preventDefault.bind(this), false);

		window.onwheel = this.preventDefault.bind(this); // modern standard
		window.onmousewheel = document.onmousewheel = this.preventDefault.bind(this); // older browsers, IE
		window.ontouchmove  = this.preventDefault.bind(this); // mobile
		document.onkeydown  = this.preventDefaultForScrollKeys.bind(this);
	}

	enableScroll() {
		if (window.removeEventListener)
			window.removeEventListener('DOMMouseScroll', this.preventDefault.bind(this), false);

		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
	}

	getValueState(){
		const {value} = this.state;
		const newValueSelected = this.state.newValue;

		if(newValueSelected && newValueSelected !== ''){
			return newValueSelected;
		}else if(((typeof value === 'string' && value.trim().length === 0) || (typeof value === 'object') && value.length === 0)){
			return this.props.defaultValue ? this.props.defaultValue : '';
		}else if(typeof this.state.value === 'object'){
			return value.value || value[0];
		}else{
			return value
		}
	}

	handleOnBlur(e) {
		setTimeout(() => {
			if (!$(document.activeElement).closest(`#${this.getPropsId()}_element`).length) {
				window['focusSelect'] = "";
				setTimeout(() => this.props.onBlur && this.props.onBlur(e), 300);
			}
		}, 0);
	}

	handleOnClick(item, e) {
		this.props.onChange(e, item.value);

		this.setNewPropertys(item, false);

		setTimeout(()=>{
			this.setState({newValue: item, searchValue: ''});
		}, 0);
	}

	handleOnKeyUpReadonly(e){
		if(e.keyCode === 13) {
			this.handleOnClickReadonly();
		}
		else if(e.keyCode === 9 && e.shiftKey && $(e.currentTarget).parents('.form__input').parent().hasClass('row')){
		}
	}

	handleOnClickReadonly(e, isCaret=false) {
		if(!this.props.disabled) {
			if (isCaret) {
				setTimeout(() => {
					this.setHiddenState(!this.state.isVisible);
				}, 0);
			}
			else {
				this.setHiddenState(!this.state.isVisible);
			}
		}

		this.props.onClick && this.props.onClick(e);
	}

	handleOnChangeSearch(e){
		this.setState({searchValue: e.currentTarget.value});
	}

	handleOnFocusReadonly(isCaret=false, e){
		if(!$(e.target).hasClass('input-autocomplete__search_readonly'))
			this.setHiddenState(false, !isCaret);

		setTimeout(() => {
			if (!window['focusSelect']) {
				window['focusSelect'] = this.getPropsId();
				this.props.onFocus && this.props.onFocus(e);
			}
		}, 0);
	}

	autocompleteDisabled(){
		const disabled = this.props.disabled;
		const readOnly = this.props.readOnly;

		if(disabled === true){
			return 'disabled'
		} else if(readOnly === true) {
			return 'readonly'
		} else {
			return ''
		}
	}

	renderListUl(){
		const { value } = this.state;
		const listOptions = this.getListOptions();
		setTimeout(() => { this.focusAutoComplete(this.getPropsId())}, 1000);

		return <div className={`input-autocomplete__result id__${this.getPropsId()}`}
					style={{top: '40px'}}
					id={`boxSearch__${this.getPropsId()}`}>

					<div className="input-autocomplete__search">
						<Icon type="search" class="material-icons" />
						<input id={`${this.getPropsId()}__search`}
							type="text"
							value={this.state.searchValue}
							onChange={this.handleOnChangeSearch.bind(this)}
							onBlur={this.handleOnBlur.bind(this)}
							onKeyDown={this.handleOnKeyUpSearch.bind(this)}
							onFocus={this.handleRemoveLiActive.bind(this)}
							aria-label={`${Realize.i18n.t("general.filter_to").replace("@", this.props.label)}`}
							autocomplete="off"
							ref="inputSearch"
							tabIndex="0"
							style={{position: 'absolute', left: '0'}}/>
					</div>

					<div className="input-autocomplete__clear-button"
						id={`${this.getPropsId()}_clear`}
						tabIndex="0"
						aria-label={`${Realize.i18n.t("inputs.autocomplete.clear")} - ${this.selectedValue()}`}
						role={'button'}
						style={{color: '#039be5', cursor: 'pointer'}}
						onFocus={this.handleRemoveLiActive.bind(this)}
						onClick={this.handleClickClear.bind(this)}
						onKeyUp={this.handleClearOptionSelected.bind(this)}
						onBlur={this.handleOnBlur.bind(this)}>
						{Realize.i18n.t("inputs.autocomplete.clear")}
					</div>

					{listOptions && listOptions.length === 0 &&
						<div className="input-autocomplete__empty-message" tabIndex="0" onBlur={this.handleOnBlur.bind(this)}>
							{Realize.i18n.t("general.empty_result_list")}
						</div>
					}

					{listOptions && listOptions.length > 0 &&
						<ul id={`${this.getPropsId()}_list`}
							className={'input-autocomplete__list'}>
							{this.renderListLI()}
						</ul>
					}
				</div>
	}

	formatOption(option) {
		return formatFieldValue(typeof option === 'string' ? option.trim() + "" : "");
	}

	renderListLI() {
		const {searchValue, isVisible} = this.state;
		let optionSelected = typeof searchValue === 'object' ? (searchValue.value ? searchValue.value : searchValue[0]) : (searchValue ? searchValue : '');
		let listOptions = this.getListOptions();

		listOptions = listOptions.filter((item)=>{
			const check = this.replaceCaracter(item.name && item.name.toLowerCase()).match(this.replaceCaracter(optionSelected && optionSelected.toLowerCase()));
			if(check) return item;
		});

		if(listOptions.length === 0){
			return <li className="input-autocomplete__empty-message" tabIndex="0" onBlur={this.handleOnBlur.bind(this)}>
						{Realize.i18n.t("general.empty_result_list")}
					</li>
		}

		return listOptions.map((item, i) => {
			return <li
						onClick={this.handleOnClick.bind(this, item)}
						onKeyUp={this.handleOnKeyUp.bind(this, item)}
						onBlur={this.handleOnBlur.bind(this)}
						className={`input-autocomplete__option`}
						style={{borderBottom: '1px solid #cccccc', whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}
						id={`${this.getPropsId()}_${i}`}
						aria-label={Realize.i18n.t('general.search.options').replace('@', item.name || item.value).replace('#', i + 1).replace('&', listOptions.length)}
						tabIndex={0}
						>
						{(this.state.value[0] === item.value || this.state.value === item.value || (this.setDefaultValue() && this.props.defaultValue === item.value)) && <Icon type="done" class="material-icons" aria-hidden={true} style={{position: 'relative', top: '7px', left: '-6px'}}/>}
						<span aria-hidden="true" title={this.formatOption(item.name || item.value)}>{this.formatOption(item.name || item.value)}</span>
					</li>
		});
	}

	getPosition(){
		const actions = this.props.actions;
		if(actions && actions.length > 0){
			const resultFilter = actions.filter((item)=> item.searcherType === "refresh");
			if(resultFilter.length > 0)
				return {right: '70px'}
		}
		return {}
	}


	getPropsId(){
		return this.props.id ? this.props.id : this.props.label ? this.props.label.replace(/ /g,"_") : 'id_autocomplete';
	}

	removeStyleReadOnly() {
		if(this.props.readOnly)
			$(`#${this.props.id}`).removeAttr("style");
	}

	render() {
		return (
			<div id={`${this.getPropsId()}_element`}>
				<div className={this.className()}>
					<LecomLabel {...this.propsWithoutCSS()}
						id={this.getPropsId()}
						active={true}
						key={`lecom--label__${this.getPropsId()}`}
						className={this.classNameReadOnly()}
					/>

					<div className="select-wrapper initialized">
						<input
							type="text"
							id={this.getPropsId()}
							name={this.props.name}
							className={`input-autocomplete__search_readonly ${this.classNameReadOnly()}`}
							value={this.selectedValue()}
							title={this.selectedValue()}
							placeholder={!this.props.readOnly ? (this.props.placeholder || Realize.i18n.t('general.select')) : ''}
							disabled={this.props.disabled}
							readOnly={true}
							onClick={!this.props.readOnly && this.handleOnClickReadonly.bind(this)}
							onFocus={!this.props.readOnly && this.handleOnFocusReadonly.bind(this, false)}
							onKeyUp={!this.props.readOnly && this.handleOnKeyUpReadonly.bind(this)}
							onBlur={this.handleOnBlur.bind(this)}
							errors={this.props.errors}
							ref="select"
							tabIndex={!this.props.readOnly ? -1 : 0}
						/>
						<div className={"caret caret_search " + this.autocompleteDisabled()}
							onFocus={!this.props.readOnly && this.handleOnFocusReadonly.bind(this, true)}
							onClick={!this.props.readOnly && this.handleOnClickReadonly.bind(this, true)}
							onKeyDown={!this.props.readOnly && this.handleOnKeyUpReadonly.bind(this)}
							hidden={this.state.isVisible}
							id={`${this.getPropsId()}_caret`}
							disabled={this.props.disabled}
							aria-disabled={this.props.disabled}
							aria-label={`${this.selectedValue() !== '' ? Realize.i18n.t("general.options_selected").replace('@', this.selectedValue()) : Realize.i18n.t("general.not_options_selected")} - ${Realize.i18n.t("general.open_options").replace('@', this.props.label)}`}
							style={this.getPosition()}
							tabIndex={(this.props.disabled || this.props.readOnly) ? -1 : 0}
							onBlur={this.handleOnBlur.bind(this)}>
							{this.autocompleteReadOnly()}
						</div>
					</div>

					{this.renderListUl()}
				</div>
			</div>
		);
	}
}
